// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__30pWA","title":"Info_title__3k5f3","selects":"Info_selects__2QTjq","requiredAsterisk":"Info_requiredAsterisk__2ZbrM"};